import { stats } from '@/mocks/comics';

const features = [
  {
    id: 1,
    title: '高清无删减',
    description: '所有韩漫资源均为高清画质，原版无删减内容，为您呈现最完整的漫画阅读体验。每一页都经过精心优化，确保画面清晰细腻。',
    icon: 'ri-hd-line',
    type: 'dark',
  },
  {
    id: 2,
    title: '海量资源库',
    description: '收录超过8,500部优质韩漫作品，涵盖恋爱、玄幻、动作、悬疑等多种类型，满足不同读者的口味需求，每日持续更新。',
    icon: 'ri-database-2-line',
    type: 'image',
  },
  {
    id: 3,
    title: '流畅阅读体验',
    description: '独家下拉式阅读设计，无需翻页即可沉浸式阅读。智能预加载技术确保画面秒开，告别等待，享受极致畅快的阅读感受。',
    icon: 'ri-smartphone-line',
    type: 'stats',
  },
];

export default function FeatureSection() {
  return (
    <section className="bg-background-100 py-16 md:py-24">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-lg mb-14">
          <span className="inline-block px-4 py-1.5 bg-background-200/70 text-foreground-600 text-xs font-medium rounded-full">
            为什么选择我们
          </span>
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-950 mt-4 leading-tight">
            为什么选择<br />尾巴漫画
          </h2>
          <p className="text-foreground-600 text-sm mt-3 leading-relaxed">
            我们用心打造极致的韩漫阅读平台，让每一部漫画都能被更好地欣赏
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          <div className="bg-foreground-950 rounded-2xl p-6 md:p-8 flex flex-col">
            <div className="w-12 h-12 rounded-xl bg-background-800 flex items-center justify-center mb-6">
              <span className="w-6 h-6 flex items-center justify-center">
                <i className="ri-hd-line text-2xl text-background-50"></i>
              </span>
            </div>
            <h3 className="font-heading text-2xl font-bold text-background-50 mb-3">
              高清无删减
            </h3>
            <p className="text-foreground-400 text-sm leading-relaxed flex-1">
              所有韩漫资源均为高清画质，原版无删减内容，为您呈现最完整的漫画阅读体验。每一页都经过精心优化，确保画面清晰细腻。
            </p>
          </div>

          <div className="bg-accent-100 rounded-2xl p-6 md:p-8 relative overflow-hidden">
            <div className="absolute inset-0 opacity-30">
              <img
                src="https://readdy.ai/api/search-image?query=Korean%20webtoon%20comic%20panels%20arrangement%2C%20various%20scenes%20from%20different%20genres%2C%20romance%20and%20action%20panels%20mixed%2C%20colorful%20digital%20art%2C%20clean%20composition%2C%20soft%20gradient%20background&width=800&height=1000&seq=feature-comic-panel&orientation=portrait"
                alt="海量韩漫资源"
                className="w-full h-full object-cover"
              />
            </div>
            <div className="absolute top-4 left-4">
              <span className="inline-flex items-center gap-2 px-3 py-1.5 bg-accent-500/80 backdrop-blur-sm text-background-50 text-xs font-medium rounded-full whitespace-nowrap">
                <span className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-database-2-line text-xs"></i>
                </span>
                8,500+
              </span>
            </div>
            <div className="relative z-10 mt-auto pt-20">
              <h3 className="font-heading text-2xl font-bold text-accent-950 mb-3">
                海量资源库
              </h3>
              <p className="text-accent-800 text-sm leading-relaxed">
                收录超过8,500部优质韩漫作品，涵盖恋爱、玄幻、动作、悬疑等多种类型，满足不同读者的口味需求，每日持续更新。
              </p>
            </div>
          </div>

          <div className="bg-background-50 rounded-2xl p-6 md:p-8 border border-background-200/70">
            <div className="mb-6">
              <span className="font-heading text-4xl font-black text-primary-500">
                {stats.satisfaction}%
              </span>
              <p className="text-foreground-600 text-sm mt-1">用户满意度</p>
            </div>
            <div className="flex items-center gap-6 mb-6">
              <div>
                <span className="font-heading text-2xl font-bold text-foreground-950">
                  {stats.dailyVisitors.toLocaleString()}
                </span>
                <p className="text-foreground-500 text-xs mt-0.5">日均访问</p>
              </div>
              <div className="w-px h-10 bg-background-200/70"></div>
              <div>
                <span className="font-heading text-2xl font-bold text-foreground-950">
                  {stats.totalComics.toLocaleString()}+
                </span>
                <p className="text-foreground-500 text-xs mt-0.5">漫画总数</p>
              </div>
            </div>
            <h3 className="font-heading text-2xl font-bold text-foreground-950 mb-3">
              流畅阅读体验
            </h3>
            <p className="text-foreground-600 text-sm leading-relaxed">
              独家下拉式阅读设计，无需翻页即可沉浸式阅读。智能预加载技术确保画面秒开，告别等待，享受极致畅快的阅读感受。
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}